import React from 'react';

interface LoopGlyphProps {
  color?: string;
  combo?: boolean;
  size?: number;
  className?: string;
}

const LoopGlyph: React.FC<LoopGlyphProps> = ({
  color = 'currentColor',
  combo = false,
  size = 19,
  className
}) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
  >
    {combo && (
      <rect
        x="1"
        y="3.5"
        width="22"
        height="17"
        rx="5"
        fill="none"
        stroke={color}
        strokeWidth="1.3"
        opacity="0.5"
      />
    )}
    <path
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m17 2 4 4-4 4"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 11v-1a4 4 0 0 1 4-4h14"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m7 22-4-4 4-4"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 13v1a4 4 0 0 1-4 4H3"
    />
  </svg>
);

export default LoopGlyph;
